import { render, staticRenderFns } from "./ControlProject.vue?vue&type=template&id=132284fe&scoped=true"
import script from "./ControlProject.vue?vue&type=script&lang=js"
export * from "./ControlProject.vue?vue&type=script&lang=js"
import style0 from "./ControlProject.vue?vue&type=style&index=0&id=132284fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132284fe",
  null
  
)

export default component.exports